import { css } from 'styled-components';
import { StyledAvatarBadge } from '../../components/AvatarBadge/AvatarBadge.styles';

/** @class BadgedAvatarMixin */
/** @method */
export var BadgedAvatarMixin = /*#__PURE__*/css(["display:inline-block;position:relative;", "{position:absolute;bottom:0;right:0;}"], StyledAvatarBadge);